import Select2 from 'vue3-select2-component/src/Select2.vue';
import Maska from 'maska'
import HighchartsVue from 'highcharts-vue'
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';

import PrimeVue from 'primevue/config';

import 'jquery'
import 'bootstrap'

require("Helpers/arrayHelper");
require("Helpers/numberHelper");
require("Helpers/stringHelper");
require("Helpers/dateHelper");

import FlexLayout from "Components/layout/FlexLayout.vue";

import SingleInput from 'Controls/SingleInput.vue';
import SingleInputBlock from 'Controls/SingleInputBlock.vue';
import SingleDatePicker from 'Controls/SingleDatePicker.vue';
import SingleDatePickerBlock from 'Controls/SingleDatePickerBlock.vue';
import DropdownBootstrap from 'Controls/DropdownBootstrap.vue';
import SingleCombobox from 'Controls/SingleCombobox.vue';
import ToolbarItem from "Headers/ToolBarItem.vue";
import Modal from "Common/notification/Modal.vue";
import Empty from "Common/notification/Empty.vue";

import commonMixin from "@/mixins/common";

import { createApp } from 'vue'

import App from '@/App.vue'

import '@/registerServiceWorker'
import router from 'Router/index'
import store from 'Store'

import i18n from 'Lang/index'
import config from 'Config'

const app = createApp(App);
app.config.globalProperties.$config = config;
app.use(Maska);

app.use(store);
app.use(router);
app.use(i18n);
app.use(PrimeVue);
app.use(HighchartsVue);

app.component('Select2', Select2);
app.component('SingleInput', SingleInput);
app.component('SingleInputBlock', SingleInputBlock);
app.component('SingleCombobox', SingleCombobox);
app.component('SingleDatePicker', SingleDatePicker);
app.component('SingleDatePickerBlock', SingleDatePickerBlock);
app.component('DropdownBootstrap', DropdownBootstrap);
app.component('FlexLayout', FlexLayout);
app.component('ToolbarItem', ToolbarItem);
app.component('Modal', Modal);
app.component('Empty', Empty);
app.component("infinite-loading", InfiniteLoading);

app.mixin(commonMixin);
app.mixin({
    data() {
        return {
            publicPath: config.BASE_URL
        }
    },
    created() {
        this.clearIsBusy();
    }
})


window.store = store;

app.mount('#app');
